module.exports = __webpack_public_path__ + "img/settings-control.64eaadd4.png";